module.exports = __webpack_public_path__ + "static/media/ralf_brockhaus.eed3ae93.png";